let quantityFilled = false;
let answerFilled = false;

console.log('Helo from product js!');

document.addEventListener('DOMContentLoaded', function() {
    attachProductQuantitySelectors();
    attachProductQuestion();
    checkATCRequirements();

    attachATCButton();
    attachUpsells();

    attachShareLink();

    const quantityInput = document.querySelector('#product--quantity-selector');
    checkCurrentDrawOdds(quantityInput.querySelector('input').value);
    var inputItem = document.getElementById('productQuantitySelector');
    var val = inputItem.value;
    var min = inputItem.getAttribute('min') ? inputItem.getAttribute('min') : 0;
    var max = inputItem.getAttribute('max') ? inputItem.getAttribute('max') : 100;
    var newVal = parseInt(((val - min) * 100) / (max - min));
    var newValOffset = Math.round(newVal / 5) - 10;
    document.querySelector('.quantity-tooltip').innerHTML = val;
    document.querySelector('.quantity-tooltip').style.left = 'calc(' + newVal + '% - ' + newValOffset + 'px)';

});


/* PRODUCT PAGE QUANTITY SELECTOR STARTS */
const attachProductQuantitySelectors = () => {
    const quantityPlus = document.querySelector('#productQuantityPlus');
    const quantityMinus = document.querySelector('#productQuantityMinus');
    const quantityInput = document.querySelector('#productQuantitySelector');

    let minQuantity = quantityInput.getAttribute('min');
    let maxQuantity = quantityInput.getAttribute('max');

    if (quantityPlus && quantityMinus && quantityInput) {
        quantityPlus.addEventListener('click', function() {
            if (parseInt(quantityInput.value)) {
                if(parseInt(quantityInput.value) < maxQuantity || maxQuantity == null) {
                    quantityInput.value = parseInt(quantityInput.value) + 1;
                    checkATCRequirements();
                    checkCurrentDrawOdds(quantityInput.value);
                    updateBtnPriceOnQuantityChange(quantityInput.value);
                }
            }
        });

        quantityMinus.addEventListener('click', function() {
            if (parseInt(quantityInput.value) > 0 && parseInt(quantityInput.value) > parseInt(minQuantity)) {
                quantityInput.value = parseInt(quantityInput.value) - 1;
                checkATCRequirements();
                checkCurrentDrawOdds(quantityInput.value);
                updateBtnPriceOnQuantityChange(quantityInput.value);
            }
        });



        if (parseInt(quantityInput.value) > parseInt(quantityInput.getAttribute('max'))) {
            quantityInput.value = quantityInput.getAttribute('max');
        }
        quantityInput.addEventListener('change', function() {
            if (parseInt(quantityInput.value) > parseInt(quantityInput.getAttribute('max'))) {
                quantityInput.value = quantityInput.getAttribute('max');
            }
            updateBtnPriceOnQuantityChange(quantityInput.value);
        });

        attachQuantityBundles(quantityInput, maxQuantity);
    }
};

document.getElementById('productQuantitySelector').addEventListener('input', function(e){

    var val = e.target.value;
    var min = e.target.getAttribute('min') ? e.target.getAttribute('min') : 0;
    var max = e.target.getAttribute('max') ? e.target.getAttribute('max') : 100;
    var newVal = parseInt(((val - min) * 100) / (max - min));
    var newValOffset = Math.round(newVal / 5) - 10;
    document.querySelector('.quantity-tooltip').innerHTML = val;
    document.querySelector('.quantity-tooltip').style.left = 'calc(' + newVal + '% - ' + newValOffset + 'px)';

    var currentInputValue = val;
    const currentDrawOdds = document.querySelector('.total-ticket--odds');
    if (currentInputValue > 0 && currentDrawOdds != null) {
        let originalTicketCount = currentDrawOdds.dataset.ticketcount;
        currentDrawOdds.classList.remove('twcss-hidden');
        let calculatedOdds = originalTicketCount / currentInputValue;
        let ticketCount = document.querySelectorAll('.current-ticket--count ');
        let ticketOdds = document.querySelector('.current-ticket--odds ');
        ticketCount.forEach(function(item){
            item.innerHTML = `${currentInputValue} Ticket${currentInputValue > 1 ? 's' : ''}`;
        });
        //ticketCount.innerHTML = `${currentInputValue} Ticket${currentInputValue > 1 ? 's' : ''}`;
        ticketOdds.innerHTML = `${calculatedOdds.toFixed(0)}`;

    } else if (currentDrawOdds != null) {
        currentDrawOdds.classList.add('twcss-hidden');
    }
});

const updateBtnPriceOnQuantityChange = (quantityValue) => {

    var inputItem = document.getElementById('productQuantitySelector');
    var val = inputItem.value;
    var min = inputItem.getAttribute('min') ? inputItem.getAttribute('min') : 0;
    var max = inputItem.getAttribute('max') ? inputItem.getAttribute('max') : 100;
    var newVal = parseInt(((val - min) * 100) / (max - min));
    var newValOffset = Math.round(newVal / 5) - 10;
    document.querySelector('.quantity-tooltip').innerHTML = val;
    document.querySelector('.quantity-tooltip').style.left = 'calc(' + newVal + '% - ' + newValOffset + 'px)';

    let bundleInfo = document.querySelector(`[data-bundleincrement="${quantityValue}"]`);
    if(bundleInfo != null || bundleInfo != undefined) {
        let bundlePrice = bundleInfo.querySelector('.bundle-price').textContent;
        updateAtcPrice(bundlePrice);
        clearActiveFromBundle();
        bundleInfo.classList.add('active');
    } else {
        clearActiveFromBundle();
        const productPrice = document.getElementById('product-price-info');

        if(productPrice != null) {
            let pricePerProduct = productPrice.dataset.price;
            let currencySymbol = productPrice.dataset.currency;
            let totalPrice = pricePerProduct * quantityValue;
            updateAtcPrice(`${currencySymbol}${totalPrice.toFixed(2)}`);
        }
    }


}

const updateAtcPrice = (price) => {
    const AtcButtonPrice = document.querySelectorAll('.current-cart-total');
    AtcButtonPrice.forEach((btnPrice) => {
        btnPrice.textContent = price;
    })
}

const checkCurrentDrawOdds = async (currentInputValue) => {
    const currentDrawOdds = document.querySelector('.total-ticket--odds');
    if (currentInputValue > 0 && currentDrawOdds != null) {
        let originalTicketCount = currentDrawOdds.dataset.ticketcount;
        currentDrawOdds.classList.remove('twcss-hidden');
        let calculatedOdds = await calculateOdds(originalTicketCount, currentInputValue);
        let ticketCount = document.querySelectorAll('.current-ticket--count ');
        let ticketOdds = document.querySelector('.current-ticket--odds ');
        ticketCount.forEach(function(item){
            item.innerHTML = `${currentInputValue} Ticket${currentInputValue > 1 ? 's' : ''}`;
        });
        ticketOdds.innerHTML = `${calculatedOdds.toFixed(0)}`;

    } else if (currentDrawOdds != null) {
        currentDrawOdds.classList.add('twcss-hidden');
    }
};

const calculateOdds = async (originalTicketCount, currentInputValue) => {
    let calculatedOdds = originalTicketCount / currentInputValue;
    return calculatedOdds;
}

attachQuantityBundles = (quantityInput, maxQuantity) => {
    let bundleIncrements = document.querySelectorAll('.bundle-increment');
    for (let i = 0; i < bundleIncrements.length; i++) {
        let bundleIncrementValue = bundleIncrements[i].dataset.bundleincrement;
        bundleIncrements[i].addEventListener('click', function() {
            if (quantityInput.value < bundleIncrements[i]){
                quantityInput.value = bundleIncrementValue;
                checkATCRequirements();
                checkCurrentDrawOdds(quantityInput.value);
            } else if (quantityInput.value + bundleIncrementValue <= maxQuantity){
                quantityInput.value = quantityInput.value + bundleIncrementValue;
                checkATCRequirements();
                checkCurrentDrawOdds(quantityInput.value);
            } else {
                quantityInput.value = maxQuantity;
                checkATCRequirements();
                checkCurrentDrawOdds(quantityInput.value);
            }

            updateBtnPriceOnQuantityChange(quantityInput.value);

        });
    }
}

const clearActiveFromBundle = () => {
    let bundleIncrements = document.querySelectorAll('.bundle-increment');

    bundleIncrements.forEach(bundleIncrement => {
        bundleIncrement.classList.remove('active');
    })
}

/* PRODUCT PAGE QUANTITY SELECTOR ENDS */



/* PRODUCT PAGE QUESTIONS STARTS */
const attachProductQuestion = () => {
    let productQuestions = document.querySelector('.answer-dropdown');
    if (productQuestions) {
        let openButton = productQuestions.querySelector('.answer-dropdown--open');
        let answersModal = productQuestions.querySelector('.answer-dropdown--answers');

        openButton.addEventListener('click', function() {
            answersModal.classList.toggle('twcss-hidden');
            attachManageAnswers(answersModal);
            attachCloseAnswers(answersModal);
        });
    }
};

const attachManageAnswers = (answersModal) => {
    let answers = answersModal.querySelectorAll('button');

    answers.forEach(answer => {
        answer.addEventListener('click', () => {
            if (answer.dataset.correct == 1 || answer.dataset.correct == '1') {
                answer.classList.add('correct--answer');
            }
            let currentAnswer = answersModal.previousElementSibling.querySelector('.answer-dropdown--current');
            currentAnswer.innerHTML = answer.innerText;
            document.querySelector('.answer-dropdown--current').setAttribute('data-answered', 'true');
            hideAnswerModal(answersModal);
            checkATCRequirements();
            hideAnswerModal(answersModal);

        })
    })

};

const attachCloseAnswers = (answersModal) => {
    //trigger close answers modal if click event is not the modal itself
    answersModal.addEventListener('click', function(e) {
        if (e.target != this) {
            return;
        }
        hideAnswerModal(answersModal);
    });
}

const hideAnswerModal = (answersModal) => {
    answersModal.classList.add('twcss-hidden');
};
/* PRODUCT PAGE QUESTIONS ENDS */


/* PRODUCT PAGE ATC BUTTON TOGGLE STARTS */
const checkATCRequirements = () => {
    const atcButtons = document.querySelectorAll('.product--atc');
    const quantityInput = document.querySelector('#productQuantitySelector');
    const answerDropdown = document.querySelector('.answer-dropdown');

    if(answerDropdown != null) {
        if (quantityInput.value > 0 && answerDropdown.querySelector('.answer-dropdown--current').dataset.answered == 'true' && atcButtons) {
            atcButtons.forEach(atcButton => {
                atcButton.disabled = false;
            });
        } else {
            atcButtons.forEach(atcButton => {
                atcButton.disabled = true;
            });
        }
    }
};
/* PRODUCT PAGE ATC BUTTON TOGGLE ENDS */


/* PRODUCT PAGE ATC BUTTON STARTS */

const attachATCButton = async () => {
    const atcButtons = document.querySelectorAll('.product--atc');
    if (atcButtons.length > 0) { 
        atcButtons.forEach(button => {
            button.addEventListener('click', function() {
                //let checkUpsells = openUpsells();
                //if (checkUpsells == null) {
                    prepATC(true);
                //}
            });
        })
    }
};

/* PRODUCT PAGE ATC ENDS */

/* PRODUCT PAGE UPSELL STARTS */
const attachUpsells = async () => {
    const upsellContainer = document.querySelector('.atc-upsells');
    closeUpsellsListeners(upsellContainer);
    let upsellATCButton = document.querySelector('.upsells--atc');
    let currentCart = await fetchCart();
    let allowedUpsells = await getAllowedUpsells();

    let upsellContinueBtn = document.querySelector('.upsells--atc--continue');

    showFirstTwoUpsells(allowedUpsells);

    if (upsellContainer) {
        for (let i = 0; i < allowedUpsells.length; i++) {
            let upsell = allowedUpsells[i];
            let upsellVariant = upsell.dataset.variantid;
            let upsellATCButton = upsell.querySelector('button');

            upsellATCButton.addEventListener('click', function() {
                addToCart(upsellVariant, 1);
                allowedUpsells[i].classList.add('twcss-hidden');
                allowedUpsells.splice(i, 1);
                showFirstTwoUpsells(allowedUpsells);
            });
        }
    }

    upsellContinueBtn.addEventListener('click', function() {
        prepATC();
        closeUpsells();
    })

    upsellATCButton.addEventListener('click', function() {
        prepATC(true);
        closeUpsells();
    });

}

const getAllowedUpsells = async () => {
    const upsellContainer = document.querySelector('.atc-upsells');
    let upsellProducts = upsellContainer.querySelectorAll('.atc-upsell--product');
    let currentCart = await fetchCart();
    let allowedUpsells = [];

    for (let i = 0; i < upsellProducts.length; i++) {
        let upsell = upsellProducts[i];
        let upsellVariant = upsellProducts[i].dataset.variantid;
        if (currentCart.items.length > 0) {
            for (let j = 0; j < currentCart.items.length; j++) {
                let cartItem = currentCart.items[j];
                if (cartItem.variant_id == upsellVariant) {
                    upsell.classList.add('twcss-hidden');
                } else {
                    upsell.classList.remove('twcss-hidden');
                    allowedUpsells.push(upsell);
                }
            }
        } else {
            upsell.classList.remove('twcss-hidden');
            allowedUpsells.push(upsell);
        }
    }

    return allowedUpsells;
};

const showFirstTwoUpsells = async (allowedUpsells) => {
    for (let i = 2; i < allowedUpsells.length; i++) {
        allowedUpsells[i].classList.add('twcss-hidden');
    }
};

const openUpsells = async () => {
    const upsellContainer = document.querySelector('.atc-upsells');

    if (upsellContainer) {
        upsellContainer.classList.remove('twcss-hidden');
    } else {
        return null;
    }
};

const closeUpsellsListeners = async (upsellContainer) => {
    const upsellClose = document.querySelector('.atc-upsells--close');
    if (upsellClose) {
        upsellClose.addEventListener('click', function() {
            closeUpsells();
        });
    }

    upsellContainer.addEventListener('click', function(e) {
        if (e.target != this) {
            return;
        }
        closeUpsells();
    });
};

const closeUpsells = async () => {
    const upsellContainer = document.querySelector('.atc-upsells');
    if (upsellContainer) {
        upsellContainer.classList.add('twcss-hidden');
    }
};

/* PRODUCT PAGE ATC PREP ENDS */



/* PRODUCT PAGE ATC STARTS */
const prepATC = async (moveToCart=false) => {
    const quantityInput = document.querySelector('#productQuantitySelector');
    const atcButton = document.querySelector('.product--atc');
    let producthandle = atcButton.dataset.producthandle;
    let currentCartQuantity = 0;
    let currentCart = await fetchCart();
    let currentVariant = await fetchVariant(producthandle);
    let quantity = quantityInput.value;
    let variantID = currentVariant.variants[0].id;
    addToCart(variantID, quantity, moveToCart);
};

const fetchCart = async () => {
    let cart = await fetch('/cart.js');
    let cartJSON = await cart.json();
    return cartJSON;
};

const addToCart = async (variantID, quantity, moveToCart=false) => {
    let cart = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            'id': variantID,
            'quantity': quantity
        })
    });
    let cartJSON = await cart.json();

    updateBasketPrice();

    if(moveToCart) {
        window.location.href = '/cart';
    }
};

const updateBasketPrice = async () => {
    let cart = await fetch('/cart.js');
    let cartJSON = await cart.json();
    let totalPrice = cartJSON.total_price;
    let currency = document.getElementById('currency-cart-money-symbol').dataset.currency;
    let formattedPrice = formatMoney(totalPrice, currency);
    let basketPrice = document.querySelector('#header-basket-total-price');
    basketPrice.innerHTML = formattedPrice;
};

const formatMoney = (cents, format) => {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    let money_format = "{{ shop.money_format }}"
    let formatString = format || money_format;


    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }


    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      let parts = number.split("."),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
        cents = parts[1] ? decimal + parts[1] : "";

      return dollars + cents;
    }


    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString.replace(placeholderRegex, value);
}

const fetchVariant = async (variantHandle) => {
    let variant = await fetch(`/products/${variantHandle}.js`);
    let variantJSON = await variant.json();
    return variantJSON;
}
/* PRODUCT PAGE ATC ENDS */

/* PRODUCT PAGE SHARE LINK STARTS */

const attachShareLink = () => {
    let shareLink = document.querySelector('.share-link');
    if(shareLink != null) {
        let shareCopy = shareLink.nextElementSibling;
        if (shareLink) {
            shareCopy.addEventListener('click', function() {
                copyShareLink(shareLink);
            });
        }
    }
}

const copyShareLink = (link) => {
    link.select();
    link.setSelectionRange(0, 99999);
    document.execCommand('copy');
    let linkValue = link.value;
    link.value = 'Copied!';
    setTimeout(function() {
        link.value = linkValue;
    }, 3000);
}

/* PRODUCT PAGE SHARE LINK ENDS */